export const FETCH_RECEIVEDINVOICE_INIT_ACTION =
  "FETCH_RECEIVEDINVOICE_INIT_ACTION";
export const FETCH_RECEIVEDINVOICE_SUCCESS_ACTION =
  FETCH_RECEIVEDINVOICE_INIT_ACTION + "_SUCCESS";
export const FETCH_RECEIVEDINVOICE_FAIL_ACTION =
  FETCH_RECEIVEDINVOICE_INIT_ACTION + "_ERROR";

export const FETCH_GENERATEDINVOICE_INIT_ACTION =
  "FETCH_GENERATEDINVOICE_INIT_ACTION";
export const FETCH_GENERATEDINVOICE_SUCCESS_ACTION =
  FETCH_GENERATEDINVOICE_INIT_ACTION + "_SUCCESS";
export const FETCH_GENERATEDINVOICE_FAIL_ACTION =
  FETCH_GENERATEDINVOICE_INIT_ACTION + "_ERROR";

export const PDF_RECEIVEDINVOICE_INIT_ACTION =
  "PDF_RECEIVEDINVOICE_INIT_ACTION";
export const PDF_RECEIVEDINVOICE_SUCCESS_ACTION =
  PDF_RECEIVEDINVOICE_INIT_ACTION + "_SUCCESS";
export const PDF_RECEIVEDINVOICE_FAIL_ACTION =
  PDF_RECEIVEDINVOICE_INIT_ACTION + "_ERROR";

export const PDF_GENERATEDINVOICE_INIT_ACTION =
  "PDF_GENERATEDINVOICE_INIT_ACTION";
export const PDF_GENERATEDINVOICE_SUCCESS_ACTION =
  PDF_GENERATEDINVOICE_INIT_ACTION + "_SUCCESS";
export const PDF_GENERATEDINVOICE_FAIL_ACTION =
  PDF_GENERATEDINVOICE_INIT_ACTION + "_ERROR";
  export const FETCH_INVOICECONFIGURATION_ACTION = "FETCH_INVOICECONFIGURATION_ACTION";
  export const FETCH_INVOICECONFIGURATION_FAIL_ACTION = FETCH_INVOICECONFIGURATION_ACTION + "_ERROR";
  export const FETCH_INVOICECONFIGURATION_SUCCESS_ACTION = FETCH_INVOICECONFIGURATION_ACTION + "_SUCCESS";